<ui-title [title]="'Current Source Systems'"></ui-title>

<ui-download></ui-download>

<ui-popup [isHidden]="modalAlert.type!='success'" [text]="modalAlert.title" [type]="modalAlert.type"></ui-popup>

<ui-alert *ngIf="modalAlert.display" [title]="modalAlert.title" [text]="modalAlert.text"
		  (onAction)="modalAlert.cb($event)"></ui-alert>

<div class="">
	<div class="card">
		<div class="card-body helper-no-padding">
			<div class="col-lg-6 float-right">
				<ui-loading [loadingText]="'loading systems'" [loading]="systems.loading"></ui-loading>
			</div>
			<ui-table [chunker]="systems.chunker" (chunked)="systems.chunkedData = $event" [filters]="true" [headers]="system.tableHeaders">
				<tr *ngFor="let system of systems.chunkedData"
					[class]="systems.selectedId==system.Id?'helper-clickable active':'helper-clickable'"
					(click)="systems_onRowClick(system)">
					<td style="width: 5%">{{ system.Id }}</td>
					<td style="width: 20%">{{ system.Name }}</td>
					<td style="width: 20%">{{ system.Description }}</td>
					<td style="width: 12.5%"><span
						class="{{helper_countSystemLoaderEnabled(system)>0?'green bold':'grey'}}">{{ helper_countSystemLoaderEnabled(system) }}</span>
						<span class="grey"> / {{ system.Loaders.length }}</span>
					</td>
					<td style="width: 22.5%">{{ system.SodApprover }}</td>
					<td style="width: 20%">
						<span class="badge bg-blue" *ngIf="system.IncludeInQARReport" style="margin-right: 5px">QAR</span>
						<span class="badge bg-grey black-important" style="text-decoration: line-through;margin-right: 5px" *ngIf="!system.IncludeInQARReport">QAR</span>
						<span class="badge bg-blue" style="margin-right: 5px" *ngIf="system.IncludeInSODReport">SOD</span>
						<span class="badge bg-grey black-important" style="text-decoration: line-through;margin-right: 5px" *ngIf="!system.IncludeInSODReport">SOD</span>
						<span class="badge bg-blue" *ngIf="system.NeedsAnomalyCheck" style="margin-right: 5px">Anomaly check</span>
					</td>
				</tr>
			</ui-table>

			<button class="btn btn-primary mt-2" (click)="system_newLoader_showModal()" *ngIf="isAdmin">Add new System</button>
		</div>
	</div>
</div>

<div class="card-separator"></div>

<div class="card" *ngIf="systems.selectedId">

	<div class="card-header">
		System <i>{{ system.data.Name }}</i> (ID: {{ system.data.Id }})
	</div>
	<div class="card-body" *ngIf="system.loading">
		<ui-loading [loadingText]="'loading system'" [loading]="system.loading"></ui-loading>
	</div>

	<div class="card-body" *ngIf="!system.loading">
		<div class="row">
			<div class="col-lg-7">
				<div class="card">
					<div class="card-header">
						Data Loaders
					</div>
					<div class="card-body">
						<p *ngIf="system.data.Loaders.length==0">no data loaders available</p>
						<div *ngIf="system.data.Loaders.length>0">
							<table class="table ui-table">
								<tr>
									<th style="width:75px">Id</th>
									<th class="">Name</th>
									<th class="">Status</th>
									<th class=""></th>
									<th class="">AD Auto Mapping?</th>
									<th class="" *ngIf="!isAuditor">Actions</th>
									<th *ngIf="isAdmin"></th>
									<th *ngIf="isAdmin"></th>
									<th *ngIf="isAdmin"></th>
								</tr>
								<tr *ngFor="let d of system.data.Loaders" style="height:45px">
									<td class="">
										{{ d.Id }}
									</td>
									<td style="width: 100%">
										{{ d.Name }}

										<!-- specific to verisk -->
										<div *ngIf="d.Name=='From Excel File'" style="    position: absolute;margin-top: -8px; margin-left: -15px;">
											<ui-uploader [parent]="self" [listVisible]="false" [text]="'Drag and Drop Excel file here'"></ui-uploader>
										</div>
									</td>
									<td class=""><span style="padding-left:0" *ngIf="!system.updatingLoader[d.Id]"
													   [class]="d.IsDeleted?'red':'green'">{{
											d.IsDeleted ? 'disabled' :
												'enabled'
										}}</span></td>
									<td class="" style="padding: 0 !important" *ngIf="!isAuditor">
										<button *ngIf="!system.updatingLoader[d.Id]" (click)="system_toggleLoader(d)"
												class="btn btn-sm  {{d.IsDeleted ? 'btn-primary':'btn-danger'}}"
												style="position: absolute;margin-top: -5px;">{{
												d.IsDeleted ? 'enable' :
													'disable'
											}}
										</button>
										<ui-loading
											style="margin-top: 7px;display: block; width:70px;margin-right: 5px;"
											[loading]="system.updatingLoader[d.Id]"></ui-loading>

									</td>
									<td class="">
										{{ d.EnrichAD ? "Yes" : "No" }}
									</td>

									<td style="padding: 0 !important" *ngIf="isAdmin">
										<button *ngIf="!system.dryrun.loading[d.Id]" (click)="system_dryRunLoader(d)"
												class="btn btn-sm btn-primary"
												style="position: absolute;margin-top: -5px;">Dry&nbsp;Run
										</button>
										<ui-loading
											style="margin-top: 7px;display: block; width:70px;margin-right: 5px;"
											[loading]="system.dryrun.loading[d.Id]"></ui-loading>

									</td>
									<td style="padding: 0 !important" *ngIf="isAdmin">
										<button *ngIf="!system.dryrun.loading[d.Id]" (click)="system_dryRunRaw(d)"
												class="btn btn-sm btn-primary"
												style="position: absolute;margin-top: -5px;">Raw&nbsp;Data
										</button>
										<ui-loading
											style="margin-top: 7px;display: block; width:70px;margin-right: 5px;"
											[loading]="system.dryrun.loading[d.Id]"></ui-loading>

									</td>
									<td style="padding: 0 !important;   " *ngIf="isAdmin && d.JSON">
										<button (click)="system_loadConfigurationForLoader(d)"
												class="btn btn-sm btn-primary"
												style=" margin-top: -2px;margin-left: 10px;">Configuration
										</button>

									</td>
									<td style="padding: 0 !important;   " *ngIf="isAdmin && d.JSON">
										<button (click)="system_deleteLoader(d)"
												class="btn btn-sm btn-danger"
												style=" margin-top: -2px;margin-left: 10px;">x
										</button>

									</td>
								</tr>
							</table>
						</div>
						<button class="btn btn-primary" (click)="system.newLoader.modalHidden = false">
							Add Loader
						</button>
					</div>
				</div>

				<div class="card-separator"></div>
				<div class="card">
					<div class="card-header">
						SOD report
					</div>
					<div class="card-body">
						<button class="btn btn-primary" (click)="system_dryRunSOD()">Dry Run</button>
					</div>
				</div>

				<div class="card-separator"></div>
				<div class="card">
					<div class="card-header">
						Configuration
					</div>
					<div class="card-body">
						<button [hidden]="system.configuration.data!=''" class="btn btn-primary" (click)="system_loadConfiguration()">Load</button>
						<pre>{{ system.configuration.data }}</pre>

						<form>
							<div class="card">
								<div class="card-body">

									<mat-checkbox color="primary"
												  [(ngModel)]="system.data.IncludeInQARReport"
												  name="cfgIncludeInQARReport"></mat-checkbox>
									Include in QAR Report?
									<br/>
									<mat-checkbox color="primary"
												  [(ngModel)]="system.data.IncludeInSODReport"
												  name="cfgIncludeInSODReport"></mat-checkbox>
									Include in SOD Report?
									<br/>

									<mat-checkbox color="primary"
												  [(ngModel)]="system.data.NeedsAnomalyCheck"
												  name="cfgNeedsAnomalyCheck"></mat-checkbox>
									Include in anomaly check?
									<br/>

									<button class="btn btn-primary" (click)="system_saveConfiguration()">Save</button>
								</div>
							</div>
						</form>


					</div>
				</div>

				<div class="card-separator"></div>

				<div class="card">
					<div class="card-header">
						SOD Approvers
					</div>
					<div class="card-body">

						<ui-input-email-list (onChange)="sodApprovers_save()" [api]="api" [(ngModel)]="system.sodApprovers.data"></ui-input-email-list>

					</div>
				</div>


			</div>
			<div class="col-lg-5">

				<div class="card">
					<div class="card-header">
						Comments
					</div>
					<div class="card-body">

						<textarea class="form-control " name="system_comments" rows="10" placeholder="Comments"
								  [(ngModel)]="system.data.Comments">
							</textarea>


						<button style=" margin-top: 5px;" mat-button class="btn-primary float-right"
								(click)="comments_save()">
							Save
						</button>
					</div>
				</div>

				<div class="card-separator"></div>

				<div class="card">
					<div class="card-header">
						Roles
					</div>
					<div class="card-body">

						<table class="table table-condensed">
							<tr>
								<th></th>
								<th>Role</th>
								<th>Standard Role Name</th>
							</tr>
							<tr *ngFor="let r of system.roles">
								<td>
									<mat-checkbox color="primary"
												  [(ngModel)]="system.pairedRoles[r.Id]" [checked]="system.pairedRoles[r.Id]"
												  name="group{{r.Id}}"></mat-checkbox>
								</td>
								<td class="helper-clickable" (click)="system.pairedRoles[r.Id]=!system.pairedRoles[r.Id]">{{ r.Name }}</td>
								<td class="helper-clickable" (click)="system.pairedRoles[r.Id]=!system.pairedRoles[r.Id]">{{ r.MappedName ? r.MappedName : '(not mapped)' }}</td>
							</tr>
						</table>
						<button class="btn btn-primary" [hidden]="system.pairing" [disabled]="system_pairedRolesCount()<2" (click)="system_pairRoles()">Pair {{ system_pairedRolesCount() }} Roles</button>

					</div>
					<div class="card-body bordered">
						<h3>Paired</h3>
						<p *ngIf="!system_hasRolePaired()">no paired roles registered</p>
						<div *ngFor="let rp of system.rolesPaired|kv" class="card" [hidden]="system.unpairing[rp.key]">
							<div class="card-header">
								{{ rp.value.pairing.Name }}
								<button class="btn btn-danger btn-sm float-right" (click)="system_unpairRoles(rp.key)">Delete</button>
							</div>
							<div class="card-body">
								<table>
									<tr>
										<th>Role</th>
										<th>Standard Role Name</th>
									</tr>
									<tr *ngFor="let r of rp.value.roles">
										<td>{{ r.Name }}</td>
										<td>{{ r.MappedName }}</td>
									</tr>
								</table>
							</div>
						</div>

						<ui-loading *ngIf="system.pairing"></ui-loading>

						&nbsp;
					</div>
					<div class="card-body bordered">
						<button class="btn btn-primary" (click)="system_openModalAddRole()">Add Role</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ui-modal [(isHidden)]="system.newLoader.modalHidden" [title]="'Add new Loader'">
	<ui-loading *ngIf="system.newLoader.saving"></ui-loading>
	<form *ngIf="!system.newLoader.saving">
		<div class="mb-1">
			<label class="col-form-label">
				Name
			</label>
			<div class="">
				<input class="form-control" [(ngModel)]="system.newLoader.entity.Name" name="snName" placeholder="Name"/>
			</div>
		</div>
		<div class="mb-1">
			<label class="col-form-label">
				Type (AD, SQL, ADSuperGroup, Hardcoded)
			</label>
			<div>
				<select class="form-control" [(ngModel)]="system.newLoader.type" name="snType">
					<option value="">--</option>
					<option value="AD">Active Directory</option>
					<option value="SQL">SQL</option>
					<option value="ADSuperGroup">Active Directory Group with filters</option>
					<option value="Hardcoded">Hardcoded</option>
					<option value="Other">Other</option>
				</select>
				<input class="form-control" *ngIf="system.newLoader.type && !helper_inArray(system.newLoader.type,[null,'','AD','SQL','ADSuperGroup','Hardcoded'])" [(ngModel)]="system.newLoader.entity.Type" name="snType" placeholder="Name"/>
			</div>
		</div>

		<div class="mb-1 " *ngIf="system.newLoader.type=='AD'">
			<label class="col-form-label">
				Active Directory Groups
			</label>
			<table class="ui-table">
				<thead>
				<tr>
					<th>Active Directory "distinguishedName"</th>
					<th>Role Name</th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let g of system.newLoader.ad.groups;let i=index">
					<td><input class="form-control" [(ngModel)]="g.Name" name="snGroupName[{{i}}]"></td>
					<td><input class="form-control" [(ngModel)]="g.Role" name="snGroupRole[{{i}}]"></td>
					<td>
						<button class="btn btn-danger" (click)="system.newLoader.ad.groups.splice(i,1)">x</button>
					</td>
				</tr>
				</tbody>
			</table>
			<button class="btn btn-primary" (click)="system.newLoader.ad.groups.push({Name:'',Role:''})">+</button>
			<button class="btn btn-primary" (click)="system_newLoader_applyConfiguration()">Apply</button>

			{{system.newLoader.ad.groups|json}}
		</div>
		<div class="mb-1 " *ngIf="system.newLoader.type=='AD'">
			<label class="col-form-label">
				Active Directory Access Groups
			</label>
			<table class="ui-table">
				<thead>
				<tr>
					<th>Active Directory "distinguishedName"</th>
					<th>Role Name</th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let g of system.newLoader.ad.accessGroups;let i=index">
					<td><input class="form-control" [(ngModel)]="g.Name" name="snGroupNameaccessGroups[{{i}}]"></td>
					<td><input class="form-control" [(ngModel)]="g.Role" name="snGroupRoleaccessGroups[{{i}}]"></td>
					<td>
						<button class="btn btn-danger" (click)="system.newLoader.ad.accessGroups.splice(i,1)">x</button>
					</td>
				</tr>
				</tbody>
			</table>
			<button class="btn btn-primary" (click)="system.newLoader.ad.accessGroups.push({Name:'',Role:''})">+</button>
			<button class="btn btn-primary" (click)="system_newLoader_applyConfiguration()">Apply</button>
		</div>

		<div class="mb-1 ">
			<label class="col-form-label">
				JSON configuration
			</label>
			<div class="">
				<textarea class="form-control" [(ngModel)]="system.newLoader.entity.JSON" name="snJson"></textarea>
			</div>
		</div>
		<div class="mb-1 ">
			<label class="col-form-label">
				Automatically map users to Active Directory users ?
			</label>
			<div class="">
				<mat-checkbox color="primary"
							  [(ngModel)]="system.newLoader.entity.EnrichAD"
							  name="snEnrichAD"></mat-checkbox>
			</div>
		</div>
		<ui-loading [loadingText]="'saving'" [loading]="system.newLoader.saving"></ui-loading>
		<button [hidden]="system.newLoader.saving" class="btn btn-primary" (click)="system_addLoader()">
			Add
		</button>
	</form>
</ui-modal>

<ui-modal [(isHidden)]="system.newSystem.modalHidden" [title]="'Add new System'">
	<ui-loading *ngIf="system.newSystem.saving"></ui-loading>
	<form *ngIf="!system.newSystem.saving">
		<div class="mb-1">
			<label class="col-form-label">
				Name
			</label>
			<div class="">
				<input class="form-control" [(ngModel)]="system.newSystem.entity.Name" name="snName" placeholder="Name"/>
			</div>
		</div>
		<ui-loading [loadingText]="'saving'" [loading]="system.newSystem.saving"></ui-loading>
		<button [hidden]="system.newSystem.saving" class="btn btn-primary" (click)="system_add()">
			Add
		</button>
	</form>
</ui-modal>


<ui-modal [(isHidden)]="system.configuration.modalHidden" [title]="'System Loader Configuration'">
	<pre>{{ system.configuration.loaderData }}</pre>
</ui-modal>


<ui-modal [(isHidden)]="system.newRole.modalHidden" [title]="'Adding role manually to a System'">
	<form>
		<div class="form-group row">
			<label class="col-lg-2">
				Name
			</label>
			<div class="col-lg-10">
				<input class="form-control" [(ngModel)]="system.newRole.name" name="newrolename" placeholder="Name"/>
			</div>
		</div>
		<ui-loading [loadingText]="'saving'" [loading]="system.newRole.saving"></ui-loading>
		<button [hidden]="system.newRole.saving" class="btn btn-primary" (click)="system_addRole()">
			Add
		</button>
	</form>
</ui-modal>


<ui-modal [(isHidden)]="system.dryrun.modalHidden" [title]="'Loader Dry Run for '+system.dryrun.title" [lg]="true">

	<ui-loading [loading]="system.dryrun.loadingAll"></ui-loading>

	<mat-accordion *ngIf="!system.dryrun.loadingAll">

		<div *ngIf="system.dryrun.raw">
			<pre [innerHTML]="system.dryrun.raw"></pre>
		</div>

		<mat-expansion-panel *ngIf="!system.dryrun.raw">
			<mat-expansion-panel-header>
				<mat-panel-title>
					<span style="text-transform: capitalize">
						Users + Roles batch
					</span>
				</mat-panel-title>
				<mat-panel-description>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<ui-table [filters]="true" [options]="system.dryrun.tableOptions"
					  [chunker]="system.dryrun.chunker" (chunked)="system.dryrun.chunkedData = $event"
					  [headers]="system.dryrun.tableHeaders"
			>
				<tr *ngFor="let row of system.dryrun.chunkedData"
				>
					<td>
						{{ row.UserName }}
					</td>
					<td>
						{{ row.RoleName }}
					</td>
				</tr>
			</ui-table>
		</mat-expansion-panel>

		<mat-expansion-panel *ngIf="!system.dryrun.raw">
			<mat-expansion-panel-header>
				<mat-panel-title>
					<span style="text-transform: capitalize">
						Roles batch
					</span>
				</mat-panel-title>
				<mat-panel-description>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<div class="alert alert-warning" *ngIf="system.dryrun.noRoles">This system does not have an automatic feed
				for the Roles
			</div>
			<table class="table ui-table table-condensed">
				<tr>
					<th>Role Name</th>
				</tr>
				<tr *ngFor="let d of system.dryrun.dataRoles">
					<td>
						{{ d.RoleName }}
					</td>
				</tr>
			</table>
		</mat-expansion-panel>
	</mat-accordion>
</ui-modal>
